import {
  GET_PRODUCTS_REQUEST, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_FAILED
} from "../actions/products_actions";

const initialState = {
  products: [],
  productsRequest: false,
  productsFailed: false
}

export const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCTS_REQUEST: {
      return {
        ...state,
        productsRequest: true
      }
    }
    case GET_PRODUCTS_SUCCESS: {
      return {
        ...state,
        products: action.products,
        productsRequest: false,
        productsFailed: false
      }
    }
    case GET_PRODUCTS_FAILED: {
      return {
        ...state,
        productsRequest: false,
        productsFailed: true
      }
    }
    default: return state
  }
}
